export const mobileControlsEventsWrapper =
  (onControlClick: (() => void) | null, onClickHandler?: () => void) => () => {
    onControlClick?.();
    if (onClickHandler) {
      onClickHandler();
    }
  };
